/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Harden_Detail6Inputs */

const en_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evals, monitoring, and output-quality tracking in production.`)
};

const ar_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقييمات ومراقبة وتتبع جودة المخرجات في الإنتاج.`)
};

const bn_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশনে ইভাল, মনিটরিং ও আউটপুট-কোয়ালিটি ট্র্যাকিং।`)
};

const de_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evals, Monitoring und Verfolgung der Ausgabequalität in der Produktion.`)
};

const es_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluaciones, monitoreo y seguimiento de calidad en producción.`)
};

const fr_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluations, surveillance et suivi de la qualité des résultats en production.`)
};

const pt_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliações, monitoramento e rastreamento da qualidade de saída na produção.`)
};

const zh_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产中的评估、监控和输出质量跟踪。`)
};

const tr_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretimde değerlendirmeler, izleme ve çıktı kalitesi takibi.`)
};

const ru_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка, мониторинг и трекинг качества вывода в проде.`)
};

const pl_svc_ai_integration_harden_detail6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena, monitorowanie i śledzenie jakości wyjściowej w produkcji.`)
};

/**
* | output |
* | --- |
* | "Evals, monitoring, and output-quality tracking in production." |
*
* @param {Svc_Ai_Integration_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_harden_detail6 = /** @type {((inputs?: Svc_Ai_Integration_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_ai_integration_harden_detail6(inputs)
	if (locale === "de") return de_svc_ai_integration_harden_detail6(inputs)
	if (locale === "es") return es_svc_ai_integration_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_ai_integration_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_ai_integration_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_ai_integration_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_ai_integration_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_ai_integration_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_ai_integration_harden_detail6(inputs)
	return en_svc_ai_integration_harden_detail6(inputs)
});
export { svc_ai_integration_harden_detail6 as "svc_ai-integration_HARDEN_detail" }